import {ValuePropertyModel} from './property.model';
import {MemberModel} from './user.model';
import {DepartmentModel, DivisionModel} from './department.model';

export class NavigationTableResponseModel {
    constructor(
        /** корневая папка */
        public folder: NavigationTableResponseItemModel = null,
        /** родительская папка, если есть */
        public parent: NavigationTableResponseItemModel = null,
        /** список элементов */
        public data: NavigationTableResponseItemModel[] | PermissionResponseModel[] = [],
        /** пагинация и сортировка */
        public pagination: NavigationTableRequestModel = new NavigationTableRequestModel(),
        public right?: {
            is_read_all: boolean;
            is_read_approved_doc: boolean;
            is_edit_signer: boolean;
            is_edit_approver: boolean;
            is_edit_settings: boolean;
            is_edit_property: boolean;
            is_create_folder: boolean;
            is_upload_file: boolean;
            is_locked_collection: boolean;
            is_delete: boolean;
            is_read_my_doc: boolean;
            use_custom_rights: number,
        },
        public loading = false,
        public signed_documents: string = null,
    ) {
    }
}

export interface PermissionResponseModel {
    folder?: NavigationTableResponseItemModel;
    collection?: NavigationTableResponseItemModel;
    file?: NavigationTableResponseItemModel;
    rights: PermissionsDocsModel;
}

export class NavigationTableResponseItemModel {
    public id: number;
    public key?: string;
    public pid: number;
    public type_str: 'file' | 'collection' | 'folder';
    public name: string;
    public description: string;

    public owner_id: number;
    public right: string;

    public signed_documents: string;

    public created_at: string;
    public updated_at: string;

    public selected = false;
    public contract_guid: string;

    public can_be_deleted: boolean;
    public is_locked?: boolean;

    public custom_properties: ValuePropertyModel[];

    public versions?: any[];

    public signers_guids?: any[];
    public approvers_guids?: any[];

    public latest_version: any;
}

export class PaginationModel {
    /** пагинация и сортировка */
    public sort_by ?: string = 'name';
    public sort ?: string = 'asc';
    public count ?: number;
    public limit = 50;
    public pages ? = 1;
    public current_page = 1;
    public guid ? = '';
    public status ?: string;
    public role? = '';
    public roles? = '';
    public board_alias?: string = '';
    public board_statuses?: string = '';
    
    public contract_is_empty?: boolean;
    public loaded_pages ?: number;
}

export class NavigationTableRequestModel extends PaginationModel {
    /** корневая папка/коллекция */
    public id = 0;

    /** тип запрашиваемых данных
     * all - папки/коллекции
     * inbox - коллекции на подпись
     * signed - коллекции подписанные
     * collection - файлы в коллекции
     */
    public filter = 'all';

    public loading = false;
    public has_contract: boolean;
}

export interface ColonsModel {
    is_editing: string; // Флаг возможности редактирования
    right: string; // Ключ прав
    title: string; // Название колонки прав
}

export interface DocsAccess {
    is_read_all: string | 'succession' | 'allowed' | 'denied';
    is_read_approved_doc: string | 'succession' | 'allowed' | 'denied';
    is_edit_signer: string | 'succession' | 'allowed' | 'denied';
    is_edit_approver: string | 'succession' | 'allowed' | 'denied';
    is_edit_settings: string | 'succession' | 'allowed' | 'denied';
    is_edit_property: string | 'succession' | 'allowed' | 'denied';
    is_create_folder: string | 'succession' | 'allowed' | 'denied';
    is_upload_file: string | 'succession' | 'allowed' | 'denied';
    is_locked_collection: string | 'succession' | 'allowed' | 'denied';
    is_delete: string | 'succession' | 'allowed' | 'denied';
    is_read_my_doc?: string | 'succession' | 'allowed' | 'denied';
}

export interface PermissionsDocsModel extends DocsAccess {
    role: MemberModel | DepartmentModel | DivisionModel;
    role_type: 'member' | 'division' | 'department';
}
